


export const Main = () => {
  return (
    <section>
      <div className="info-blocks w-full h-full bg-black-main flex  justify-center ">
        <div className="w-full h-96 bg-black-main p-5 flex  justify-center align-center  text-center ">
          <div>
            <h2 className="w-96 text-center text-yellow-main text-3xl mb-10">Explore Our Product Range</h2>
            <p className="w-96 text-hero-color text-lg leading-10">Welcome to our website, your one-stop destination for a wide range of high-quality athletic shoes. Discover our diverse collection, carefully curated to cater to all your fitness needs. Whether you're a runner, a gym enthusiast, or a sports lover, we have the perfect pair of shoes to accompany you on your athletic journey.</p>
          </div>
        </div>

        <div className="bg-light-gray w-full h-96 p-5 flex justify-center text-center border-0 border-teal-main ">
          <div>
            <h2 className="w-96 text-yellow-main text-center text-3xl mb-10">Why Choose Us?</h2>
            <p className="w-96 text-white text-lg leading-10">Here at our website, we pride ourselves on delivering excellence to our customers. With a strong commitment to quality, innovation, and customer satisfaction, we stand apart from the competition. Our shoes are designed to withstand the rigors of your active lifestyle while keeping you stylish and comfortable throughout your journey.</p>
          </div>
        </div>


      </div>
    </section>
  )
}


export default Main;